<div class="buttons-wrapper">
  <a (click)="openLinkApp('iOS')" href="https://apps.apple.com/us/app/channels-business-phone-app/id1491508096" target="_blank">
    <div class="shop-button" id="app-store-btn"></div>
  </a>
  <a (click)="openLinkApp('Android')" href="https://play.google.com/store/apps/details?id=com.channelsmobile" target="_blank">
    <div class="shop-button" id="google-play-btn"></div>
  </a>
</div>
